/* eslint-disable @typescript-eslint/no-explicit-any */
// import { cn } from "@/lib/utils";
import { cn } from "@/lib/utils";
import { useAppDispatch, useAppSelector } from "@/src/app/hooks";
import { Button } from "@/src/components/Button/Button";
import InputComponent from "@/src/components/Input/Input";
import AppendInput from "@/src/components/PhoneInput/AppendInput";
import { Label } from "@/src/components/Text/Text";
// import { Combobox } from "@/src/components/shad/combobox";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
} from "@/src/components/shad/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/src/components/shad/popover";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/src/components/shad/select";
import { setBeneficiaryPayment } from "@/src/features/tradeSlice";
import useUrlState from "@/src/hooks/use-url-state";
import { useCountries } from "@/src/hooks/useCountries";
import { usePaymentMethods } from "@/src/hooks/usePaymentMethods";
// import { getFlagEmoji } from "@/src/utils";
import { Check } from "lucide-react";
import { ChevronDown } from "lucide-react";
// import { Check, X } from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

interface Props {
  country_id: number;
}

const AddBeneficiary = ({ country_id }: Props) => {
  const { t } = useTranslation();
  const trans = (key: string) =>
    t(`app.buysell.sellPayments.oneTimeBeneficiary.${key}`);
  const { user } = useAppSelector((state) => state?.user);
  const [, setModal] = useUrlState("add_payment");
  const {
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();
  const dispatch = useAppDispatch();
  const [provider, setProvider] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const { paymentMethods, isLoading } = usePaymentMethods({
    country_id,
  });
  const selectedProvider = paymentMethods?.find(
    (item) => item?.name === provider
  );

  const foundFields: any = selectedProvider?.fields;
  const { countries } = useCountries();

  const filteredPayments = paymentMethods?.filter((pm) => pm.allow_credit);

  const selectedCountry =
    countries?.info.find((item) => item?.short_code_iso3 === countryCode) ??
    countries?.info.find((item) => item?.name === user?.country);

  const addPayment = async () => {
    const fieldsToPass = Object.fromEntries(
      foundFields?.map((filed: any) => [
        `${filed.field}`,
        filed?.type === "phone"
          ? `+${countryCode}${getValues(filed?.field)}`
          : getValues(filed?.field),
      ])
    );
    dispatch(
      setBeneficiaryPayment({
        fields: fieldsToPass,
        service_id: selectedProvider?.id.toString() ?? "",
        service_image: selectedProvider?.image,
        service_name: selectedProvider?.name,
      })
    );
    toast.success("Payment method added");
    setModal(undefined);
  };

  const submit = () => {
    addPayment();
  };

  if (isLoading) return null;
  return (
    <div className="grid gap-2">
      <div className="grid gap-1">
        <Label>{trans("modal.forms.provider.label")}</Label>
        <Select onValueChange={setProvider}>
          <SelectTrigger>
            <SelectValue
              placeholder={trans("modal.forms.provider.placeholder")}
            />
          </SelectTrigger>
          <SelectContent>
            {filteredPayments?.map((item) => (
              <SelectItem key={item?.id} value={item?.name}>
                {item?.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {foundFields?.map((field: any, index: number) =>
        field?.type === "phone" ? (
          <AppendInput
            key={index}
            type={field?.type}
            label={field.label}
            {...register(field.field, { required: field.required })}
            errors={errors[field.field]?.message as string}
            selectOption={
              <Popover>
                <div className=" grid ">
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      role="combobox"
                      className={cn(
                        " flex justify-between text-black font-medium w-full items-center border-gray-200 bg-input-field rounded-md px-3 py-2.5 text-sm  shadow-none dark:bg-grey-500 dark:text-white whitespace-nowrap border-0"
                      )}
                    >
                      {selectedCountry ? (
                        <>
                          <img
                            src={selectedCountry?.image}
                            alt=""
                            className="h-4 w-4"
                          />
                          +{selectedCountry?.short_code_iso3}
                        </>
                      ) : (
                        <span>Eg. +233</span>
                      )}
                      <ChevronDown className="ml-2 h-4 w-4 shrink-0 opacity-50 " />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent
                    className={cn(
                      ` max-h-[--radix-popover-content-available-height] overflow-y-scroll p-0 min-w-[var(--radix-popover-trigger-width)]  z-[100] `
                    )}
                    align="start"
                  >
                    <Command>
                      <CommandInput placeholder={`Search country`} />
                      <CommandEmpty>Nothing found.</CommandEmpty>
                      <CommandGroup>
                        {countries?.info.map((item, index) => (
                          <CommandItem
                            key={index}
                            onSelect={() => {
                              setCountryCode(item?.short_code_iso3);
                            }}
                            value={item?.name + item?.short_code_iso3}
                          >
                            <Check
                              className={cn(
                                "mr-2 h-4 w-4",
                                countryCode === item?.short_code_iso3
                                  ? "opacity-100"
                                  : "opacity-0"
                              )}
                            />

                            <div className="flex items-center h-1">
                              <span className="text-lg mr-2">
                                <img
                                  src={item?.image}
                                  alt=""
                                  className="h-4 w-4"
                                />
                              </span>
                              <span>
                                {item?.name} (+{item?.short_code_iso3})
                              </span>
                            </div>
                          </CommandItem>
                        ))}
                      </CommandGroup>
                    </Command>
                  </PopoverContent>
                  {/* {errors && (
                                  <span className="text-red-500 text-xs font-medium">{errors.}</span>
                              )} */}
                </div>
              </Popover>
            }
          />
        ) : field?.type === "select" ? (
          <div>
            <Label>{field.label}</Label>
            <Select onValueChange={(val) => setValue(field?.field, val)}>
              <SelectTrigger>
                <SelectValue placeholder={`Select ${field.label}`} />
              </SelectTrigger>
              <SelectContent>
                {field?.options?.map((item: any, index: number) => (
                  <SelectItem key={index} value={item}>
                    {item}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        ) : (
          <InputComponent
            key={index}
            type={field?.type}
            label={field.label}
            errors={errors[field.field]?.message as string}
            {...register(field.field, { required: field.required })}
          />
        )
      )}
      <Button onClick={submit} className="mt-5">
        {trans("modal.forms.addbutton")}
      </Button>
    </div>
  );
};

export default AddBeneficiary;
